import { apiClient } from '../config/api-config';

/**
 * Backend NDA Status Response
 * Returned by GET /api/v1/my-account/nda-status
 */
export interface BackendNdaStatusResponse {
  status: string;
  reviewerComments: string | null;
  rejectionReason: string | null;
  nextAction: string | null;
  ndaAttemptId: string;
  attemptNumber: number;
}

/**
 * NDA Status API service
 * Handles fetching detailed NDA status information including rejection reasons
 */
export const ndaStatusService = {
  /**
   * Fetch detailed NDA status from the API
   * Used in router loaders to get rejection reason when NDA status is REJECTED
   */
  getNdaStatus: async (): Promise<BackendNdaStatusResponse> => {
    const response = await apiClient.axios.get<BackendNdaStatusResponse>(
      '/my-account/nda-status'
    );
    return response.data;
  },
};

export default ndaStatusService;
